export const stringContainsSubstring = (
  string: string,
  subString: string,
): boolean => {
  if (string && subString) {
    return string.includes(subString);
  }
  return false;
};
